import * as React from 'react';

import { IProps } from './GoogleDataChart.types';

export class GoogleDataChart extends React.Component<IProps> {
  private readonly chartNode: React.RefObject<
    HTMLDivElement
  > = React.createRef();
  private chart: any;

  public componentDidMount() {
    this.loadChart();
  }
  public componentDidUpdate() {
    this.loadChart();
  }

  public render() {
    const { className } = this.props;

    return <div className={className} ref={this.chartNode} />;
  }

  private loadChart = () => {
    const { config, viewId } = this.props;

    if (viewId === null) {
      return;
    }

    const chartConfig = {
      ...config,
      chart: {
        ...config.chart,
        container: this.chartNode.current,
      },
    };
    this.chart = new (window as any).gapi.analytics.googleCharts.DataChart(
      chartConfig,
    );
    this.chart
      .set({
        query: {
          ids: `ga:${viewId}`,
        },
      })
      .execute();
  };
}
